import Marquee from "react-fast-marquee";

const MARQUEE_SPEED = 30;

const words = ["Cosmetics", "Ayurveda", "Nutraceuticals", "Doctor-Led", "Science-Backed", "NDA Protected", "Export Ready"];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="py-10 border-b border-navy/10 bg-ivory overflow-hidden">
      <Marquee speed={MARQUEE_SPEED} gradient={false} autoFill>
        {words.map((w) => (
          <span key={w} className="mx-8 flex items-center gap-8">
            <span className="font-display italic text-3xl sm:text-4xl text-navy/80">{w}</span>
            <span className="w-2 h-2 rounded-full bg-navy/30" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
